import { render, staticRenderFns } from "./InvitationDialog.vue?vue&type=template&id=6fabfdef&scoped=true"
import script from "./InvitationDialog.vue?vue&type=script&lang=js"
export * from "./InvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./InvitationDialog.vue?vue&type=style&index=0&id=6fabfdef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabfdef",
  null
  
)

export default component.exports